<script setup>
defineProps({
  title: {
    type: String,
    default: 'Segment',
  },
  icon: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <slot />
</template>
